/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerPrices } from './getSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerPrices';
import { GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerTravelersInner } from './getSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerTravelersInner';
import { GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerCorrection } from './getSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerCorrection';

export interface GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInner {
  /**
   * 列の分類情報<br/> seat：座席<br/> header：ヘッダ<br/> facility：設備<br/> partition：パーティション<br/> aisle：通路
   */
  columnType: GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInner.ColumnTypeEnum;
  /**
   * 座席番号<br/> 番号+列番号の形式(例：34B)<br/> 列の分類情報がパーティションの場合は\"\"(空欄)
   */
  seatNumber: string;
  /**
   * 設備コード<br/> 列の分類情報がfacility、または列の分類情報が座席でDxAPIから返却された設備情報に座席番号が存在する場合、DxAPIから返却された情報を返却する。
   */
  facilityCode: string;
  /**
   * characteristicコード<br/> 列の分類情報がseatの場合、DxAPIから返却された情報を返却する。
   */
  seatCharacteristicsCodes: Array<string>;
  /**
   * 座席利用可否情報<br/> occupied：DxAPIからoccupiedが返却された場合<br/> ※ 当該PNRの搭乗者がSSR登録済みの座席もDxAPIからoccupiedで返却され、それをそのまま返却する。<br/> blocked：以下のいずれかに合致する場合<br/> 1.当該PNRの全搭乗者に対して、DxAPIからblockedが返却された場合<br/> 2.DxAPIからavailableが返却されたが、当該座席についてSSRステータスUN/NO/UCの搭乗者が存在する<br/> 3.当該座席のcharacteristicコードに\"CH\"(有料座席)が含まれるかつ他社運航便である<br/> 4.当該座席のcharacteristicコードに\"\"CH\"\"(有料座席)が含まれるかつNHグループ便名NHグループ運航便で、かつ有料ASR席選択可能条件（※）を満たさない<br/> 　※informative以外の場合、以下の条件のすべてを満たす。informativeの場合、ASWDB(マスタ)の有料サービス情報テーブルから取得した有料ASRが可の場合とする。<br/> 　1.概要に記載の航空券の有効性判定処理にて有効な航空券を保持している搭乗者のみである<br/> 　2.海外ツアー予約PNRではない<br/> 　3.PNR情報取得APIでAncillaryが可<br/> 　4.PNR情報取得APIで取得したグループPNR区分がfalse、または、ASWDB(マスタ)の有料サービス情報にて有料ASRに対するグループPNR申込可否が可<br/> 　5.PNR情報取得APIで取得した社員用PNR区分がfalse、または、ASWDB(マスタ)の有料サービス情報にて有料ASRに対する社員用PNR申込可否が可<br/> 　6.有料ASR席免除用SKの登録に失敗した搭乗者が存在しない<br/> 5.当該座席のcharacteristicコードに\"\"L\"\"(カウチ席)が含まれるかつNHグループ便名NHグループ運航便で、かつカウチ席選択可能条件(※)を満たさない<br/> 　※informative以外の場合、概要に記載のカウチ申し込み不可条件に該当せず買取カウチ席でない場合とし、 　　informativeの場合、以下すべての条件を満たす場合とする。<br/> 　1.買取カウチ席でない（買取カウチ席はプロパティテーブルから取得したCharacteristicsコードがU|1C|Qのいずれかの場合とする）<br/> 　2.海外ツアー予約ではない(PNRオーナーオフィスコードの4～6桁が1F3の場合)<br/> 　3.有料サービステーブルでカウチが可<br/> 6.SK COUCの登録に失敗した搭乗者が存在する<br/> ※informativeの場合は本条件を適用しない<br/> 7.当該座席のcharacteristicコードがASWDB(マスタ)の座席制限として、SSRコードの条件なしで制限が存在する。<br/> 制限は、NH運航便用の制限にて判定する。<br/> ※informativeの場合のみ本条件を適用する<br/> available：上記以外の場合。<br/> ※ ただし搭乗者毎のseatAvailabilityStatusが全員blockedである場合は座席単位の利用可否をavailableと判定してもblockedに上書きして返却する。<br/>
   */
  seatAvailabilityStatus: GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInner.SeatAvailabilityStatusEnum;
  /**
   * カウチ席かどうか<br/> Characteristicsコードが\"L\"(カウチ)の場合、trueとする。
   */
  isCouchSeat: boolean;
  /**
   * 有料ASR席かどうか<br/> 座席情報に設定されているCharacteristicsコードに\"CH\"(有料座席)が含まれるかつNHグループ便名NHグループ運航便で、かつ1人でも座席金額が0より大きい搭乗者が存在する場合、trueとする。
   */
  isChargeableAsrSeat: boolean;
  /**
   * チャイルドシート装着可能席かどうか<br/> 以下の座席の場合、trueとする。<br/> 　1.窓側席<br/> 　2.2本通路機材の場合の中央ブロック席<br/> 　　※ 通路が2本あり、両方の通路に挟まれているブロックの座席すべてを指す
   */
  isChildSeatAttachable: boolean;
  /**
   * 幼児または同伴幼児の有無<br/> 幼児がいる座席であるとDxAPIから返却された場合にtrueとする。
   */
  isInfantSeated: boolean;
  /**
   * 当該座席が同伴幼児ありの搭乗者が座席指定可能な座席であるか。<br/> 以下の全ての条件に該当する場合にfalse、それ以外の場合true。<br/> 　1.当該セグメントが国内線、またはNHグループ運航の国際線である<br/> 　2.幼児または同伴幼児がいる座席が当該ブロックに含まれる
   */
  isAssignableSeatForInfant: boolean;
  correction: GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerCorrection;
  prices: GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerPrices;
  /**
   * 当該座席に対する搭乗者ごとの情報
   */
  travelers: Array<GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInnerTravelersInner>;
}
export namespace GetSeatmapsResponseDataSeatmapsDecksInnerSeatsInnerRowsInnerColumnsInner {
  export type ColumnTypeEnum = 'seat' | 'header' | 'facility' | 'partition' | 'aisle';
  export const ColumnTypeEnum = {
    Seat: 'seat' as ColumnTypeEnum,
    Header: 'header' as ColumnTypeEnum,
    Facility: 'facility' as ColumnTypeEnum,
    Partition: 'partition' as ColumnTypeEnum,
    Aisle: 'aisle' as ColumnTypeEnum,
  };
  export type SeatAvailabilityStatusEnum = 'available' | 'blocked' | 'occupied';
  export const SeatAvailabilityStatusEnum = {
    Available: 'available' as SeatAvailabilityStatusEnum,
    Blocked: 'blocked' as SeatAvailabilityStatusEnum,
    Occupied: 'occupied' as SeatAvailabilityStatusEnum,
  };
}
